module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "companies-index"
    }
  }, [_c('h1', {
    staticClass: "pull-left"
  }, [_vm._v("Empresas")]), _c('router-link', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "to": "/configuracoes/empresas/criar"
    }
  }, [_c('div', {
    staticClass: "icon-more"
  }, [_vm._v("+")]), _vm._v(_vm._s(_vm.$t('companies.actions.create')))]), _c('div', {
    staticClass: "clear"
  }), _c('div', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.loadCompanies),
      expression: "loadCompanies"
    }],
    staticClass: "table"
  }, [_c('div', {
    staticClass: "table-header table-row"
  }, [_c('div', {
    staticClass: "table-col table-col-80"
  }, [_vm._v(_vm._s(_vm.$t('companies.attributes.name')) + " / " + _vm._s(_vm.$t('companies.attributes.domain')))]), _c('div', {
    staticClass: "table-col table-col-50"
  }, [_vm._v(_vm._s(_vm.$t('companies.attributes.email')) + " / " + _vm._s(_vm.$t('companies.attributes.status')))]), _c('div', {
    staticClass: "table-col table-col-collapsed"
  }, [_vm._v(_vm._s(_vm.$t('companies.attributes.usersCount')))]), _c('div', {
    staticClass: "table-col table-col-50"
  }, [_vm._v(_vm._s(_vm.$t('companies.attributes.managersCount')))]), _c('div', {
    staticClass: "table-col table-col-30"
  }, [_vm._v(_vm._s(_vm.$t('companies.attributes.status')))]), _c('div', {
    staticClass: "table-col table-col-30"
  }, [_vm._v(_vm._s(_vm.$t('companies.attributes.voip')))]), _c('div', {
    staticClass: "table-col table-col-50",
    attrs: {
      "title": ((_vm.$t('companies.attributes.usedMinutes')) + "/" + (_vm.$t('companies.attributes.paidMinutes')))
    }
  }, [_vm._v(_vm._s(_vm.nameLetters(_vm.$t('companies.attributes.usedMinutes'))) + "/ " + _vm._s(_vm.nameLetters(_vm.$t('companies.attributes.paidMinutes'))))]), _c('div', {
    staticClass: "table-col table-col-80"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.text_field_filter),
      expression: "text_field_filter"
    }],
    staticClass: "search-field form-control",
    attrs: {
      "placeholder": _vm.$t('companies.actions.search'),
      "type": "text"
    },
    domProps: {
      "value": (_vm.text_field_filter)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.filter.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.text_field_filter = $event.target.value
      }
    }
  })])]), _c('div', {
    staticClass: "table-body"
  }, [_c('hr'), _vm._l((_vm.companies), function(company) {
    return _c('list-item', {
      key: company.id,
      attrs: {
        "company": company
      },
      on: {
        "updated": _vm.companyUpdated
      }
    })
  })], 2)]), _c('div', {
    attrs: {
      "align": "center"
    }
  }, [_c('loading', {
    attrs: {
      "loading": _vm.loading
    }
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "light-gray-text light-text"
  }, [_vm._v(_vm._s(_vm.$t('general.feedback.noResults')))])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-665d43c2!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/companies/index.vue
// module id = 1153
// module chunks = 1